import "./AppUI.css";
import Login from "./components/LoginComponent/Login";
import MainComponent from "./components/MainComponent/MainComponent";
import MenuComponent from "./components/MenuComponent/MenuComponent";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AppProvider, useAppContext } from "./AppContext";
import { useBreakpointValue } from "@chakra-ui/react";
import { trackPageView, initializeGA, setUserID, removeUserID, setProperties } from "./lib/GA";
import * as Sentry from "@sentry/react";
import SupportWidget from "./components/Support/SupportWidget";
import VerifyAccount from "./components/VerifyAccount/VerifyAccount";


Sentry.init({
  dsn: "https://dd5c3ca0cf1f768377f4197f1246f978@o4507664126181376.ingest.us.sentry.io/4508016182820864",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, 
  tracePropagationTargets: [process.env.REACT_APP_API_ENDPOINT, process.env.REACT_APP_ADEC_API_ENDPOINT],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  environment: window.location.href.includes('/app.getviva')? 'prod' : (window.location.href.includes('/qa-app.getviva')? 'qa' : 'dev'),
  enabled: !process.env.REACT_CI_TEST_RUN
});


function App() {
  const { isLoading, user, selectedBusiness } = useAppContext();
  const location = useLocation();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const [actionBarItems, setActionBarItems] = useState([]);

  useEffect(() => {
    initializeGA(process.env.REACT_APP_GA_TRACKING_ID);
  }, []);

  const toggleMenu = () => {
    setIsMenuCollapsed(!isMenuCollapsed);
  };

  useEffect(() => {
    setIsMenuCollapsed(isMobile);
  }, [isMobile]);

  const addActionBarItem = (item) => {
    setActionBarItems((prevItems) => [...prevItems, item]);
  };

  const removeActionBarItem = (itemId) => {
    setActionBarItems((prevItems) =>
      prevItems.filter((item) => item.id !== itemId)
    );
  };

  useEffect(() => {
    if (selectedBusiness?.bid) {
      setProperties({ bid: selectedBusiness.bid });
    }
  }, [selectedBusiness]);

  useEffect(() => {
    if (user && user.id) {
      setUserID(user.id);
    } else {
      removeUserID();
    }
  }, [user]);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return isLoading ? (
    <div></div>
  ) : location.pathname.startsWith('/verify/') ? (
    <Routes>
      <Route path="/verify/:tokenId" element={<VerifyAccount />} />
    </Routes>
  ) : user ? (
    <div id="container" className="App">
      <MenuComponent
        isCollapsed={isMenuCollapsed}
        isMobile={isMobile}
        setIsCollapsed={setIsMenuCollapsed}
        toggleMenuCollapse={toggleMenu}
        addActionBarItem={addActionBarItem}
        removeActionBarItem={removeActionBarItem}
      />
      <MainComponent
        isCollapsed={isMenuCollapsed}
        isMobile={isMobile}
        setIsCollapsed={setIsMenuCollapsed}
        toggleMenuCollapse={toggleMenu}
        addActionBarItem={addActionBarItem}
        removeActionBarItem={removeActionBarItem}
        actionBarItems={actionBarItems} // Pass the ActionBar items to MainComponent
      />
      <SupportWidget />
    </div>
  ) : (
    <Login />
  );
}

function AppWithRouter() {
  return (
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  );
}

export default AppWithRouter;
